export enum VideoJSUseMode {
  EDIT,
  WATCH
}